import React from 'react';
//import ProfileDropdown from '../../customDropdown';
import EgenDokumentasjonsDropdown from '../../egenDokumentasjonsDropdown';
import { useRetrieveOrderedProductsGraphQLTest } from '../../../hooks/orderedProducts';
import Loader from '../../loader';
import CSS from './profile.module.css';

export function ProfilePage() {

    const {products, isLoading, isError} = useRetrieveOrderedProductsGraphQLTest();
    

    const getCategoryTitle = (categoryId) => {
        switch (categoryId) {
          case 3:
            return "LAKKANLEGG";
          case 4:
            return "RETTE-OG-LØFTEUTSTYR";
          // Legg til flere saker for andre kategori-id-er
          case 5:
            return "VENTILASJON OG KOMPRESSOR";
          case 6:
            return "I BLANDEROM";
          case 7:
            return "DIVERSE";
          case 8:
            return "SVEISEUTSTYR";
          default:
            return "Ukjent kategori"; 
        }
      };

    const productsByCategory = products.reduce((acc, product) => {
        const categoryId = product.attributes.product.data.attributes.category.data.id;

        if (!acc[categoryId]) {
            acc[categoryId] = [];
        }

        acc[categoryId].push(product);
        return acc;
    }, {});

    if(isLoading) {
        return(<div><Loader /></div>)
    }

    if(isError) {
        <p>Oida, noe gikk galt! Vennligst last inn siden på nytt</p>
    }

    return(
        
        <div className="col-xl-12 m-auto">
          <div className="mt-5">
            <h1>
              PRODUKTOVERSIKT
            </h1>
            <p className={CSS.p}>Her finner du en liste over dine produkter</p>
          </div>
            {Object.keys(productsByCategory).map((categoryId) => (
                <EgenDokumentasjonsDropdown
                key={categoryId}
                title={getCategoryTitle(parseInt(categoryId))}
                products={productsByCategory[categoryId]}
                />
            ))}
            <div className="mb-5"></div>
        </div>

    )

}

export default ProfilePage;